import { useEffect } from 'react'

import CheckupParameters from './CheckupParameters'
import { checkTouchEvents } from 'utils/checkTouchEvents'
import { Events } from 'constants/events'

const useTrackCheckup = () => {
  useEffect(() => {
    const handleResize = () => {
      CheckupParameters.set({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }
    handleResize()
    window.addEventListener(Events.RESIZE, handleResize)
    return () => window.removeEventListener(Events.RESIZE, handleResize)
  }, [])

  useEffect(() => {
    const handleMouseMove = () => {
      CheckupParameters.set({
        lastMouseMoveTime: new Date(),
      })
    }
    window.addEventListener(Events.MOUSEMOVE, handleMouseMove)
    return () => window.removeEventListener(Events.MOUSEMOVE, handleMouseMove)
  }, [])

  useEffect(() => {
    const handleTouch = () => {
      CheckupParameters.set({
        lastTouch: new Date(),
      })
    }
    window.addEventListener(Events.TOUCHEND, handleTouch)
    return () => window.removeEventListener(Events.TOUCHEND, handleTouch)
  }, [])

  useEffect(() => {
    CheckupParameters.set({
      userAgent: window.navigator.userAgent,
      isTouchEvents: checkTouchEvents(),
    })
  }, [])
}

export default useTrackCheckup
